var map = {
	"./admin/map/driver-marker-icon-primary-stale.svg": 18541,
	"./admin/map/driver-marker-icon-primary.svg": 77161,
	"./admin/map/driver-marker-icon-stale.svg": 43988,
	"./admin/map/driver-marker-icon.svg": 20228,
	"./admin/map/restaurant_pinlet-2-medium-gray.png": 23713,
	"./admin/map/restaurant_pinlet-2-medium-outside.png": 76835,
	"./admin/map/restaurant_pinlet-2-medium.png": 69105,
	"./animated/animated_scooter.svg": 84581,
	"./animated/loading_spinner.svg": 3160,
	"./content/badge-app-store.svg": 70057,
	"./content/badge-google-play.svg": 84960,
	"./content/driver-screen-1.svg": 43155,
	"./content/driver-screen-2.svg": 36064,
	"./content/driver-screen-3.svg": 92977,
	"./content/signoff.png": 36599,
	"./deliver-max-image.png": 45545,
	"./device-frame.png": 76269,
	"./email/delivereasy-full-stacked-rgb-email.png": 20216,
	"./email/delivereasy-logo-email.png": 77432,
	"./icons/add.svg": 49814,
	"./icons/alarm-bell-1.svg": 6172,
	"./icons/alert-circle.svg": 51886,
	"./icons/allowances-no-talking.svg": 22989,
	"./icons/ambulance-call.svg": 46294,
	"./icons/arrow-down-1.svg": 54463,
	"./icons/arrow-left.svg": 68502,
	"./icons/arrow-right.svg": 79989,
	"./icons/attachment-1.svg": 37996,
	"./icons/bin-2.svg": 40593,
	"./icons/bread-wheat.svg": 62991,
	"./icons/calendar-3.svg": 80515,
	"./icons/car-1.svg": 36023,
	"./icons/car-clouds.svg": 29144,
	"./icons/check-1.svg": 28493,
	"./icons/check.svg": 16555,
	"./icons/chef-gear-roller-whisk.svg": 70679,
	"./icons/chevron-right.svg": 62471,
	"./icons/cloud-warning.svg": 29983,
	"./icons/common-file-text-remove.svg": 21192,
	"./icons/credit-card-1-alternate.svg": 6790,
	"./icons/credit-card-amex.svg": 27491,
	"./icons/credit-card-mastercard.svg": 68714,
	"./icons/credit-card-visa.svg": 14989,
	"./icons/cursor-choose-1.svg": 24597,
	"./icons/custom-shaka-sign.svg": 45189,
	"./icons/delete.svg": 47708,
	"./icons/discount-dollar-dash.svg": 35760,
	"./icons/dollar.svg": 63267,
	"./icons/ecology-leaf.svg": 1092,
	"./icons/fruit-acorn.svg": 41465,
	"./icons/hash.svg": 64989,
	"./icons/headphones-customer-support.svg": 86943,
	"./icons/hour-glass.svg": 80160,
	"./icons/information-circle.svg": 29422,
	"./icons/list-bullets-1.svg": 45499,
	"./icons/maps-pin-1.svg": 46020,
	"./icons/milk-carton.svg": 60084,
	"./icons/money-bags.svg": 40533,
	"./icons/move-expand-vertical.svg": 88734,
	"./icons/navigation-menu.svg": 82265,
	"./icons/night-moon-new.svg": 47740,
	"./icons/official-building-3.svg": 72939,
	"./icons/organic-plant-grow-1.svg": 83622,
	"./icons/password-type.svg": 58819,
	"./icons/payment-afterpay.svg": 64834,
	"./icons/pencil.svg": 56114,
	"./icons/phone-action-email-1.svg": 14487,
	"./icons/phone-hand-hold-1.svg": 18597,
	"./icons/phone.svg": 93079,
	"./icons/pin.svg": 11442,
	"./icons/question-circle.svg": 84662,
	"./icons/question-help-message.svg": 82333,
	"./icons/regular-phone-action-email.svg": 81616,
	"./icons/remove.svg": 55457,
	"./icons/restaurant-fork-knife.svg": 18569,
	"./icons/scooter.svg": 31874,
	"./icons/search-alternate.svg": 11216,
	"./icons/send-email.svg": 78612,
	"./icons/shipping-logistic-estimate-time-arrival-1.svg": 65159,
	"./icons/shop-1.svg": 28587,
	"./icons/shopping-bag-side.svg": 67060,
	"./icons/style-two-pin-warning.svg": 91004,
	"./icons/subtract.svg": 22009,
	"./icons/sync-location.svg": 89544,
	"./icons/synchronize-arrow-1.svg": 74091,
	"./icons/synchronize-arrows-square.svg": 44832,
	"./icons/tags-favorite.svg": 95887,
	"./icons/technology-contact-access-check.svg": 868,
	"./icons/time-clock-circle.svg": 1952,
	"./icons/vaccine-protection-syringe.svg": 80714,
	"./icons/weather-sun.svg": 75742,
	"./icons/wild-bird-2.svg": 75954,
	"./icons/wind-cloud-sun.svg": 61026,
	"./icons/wind-velocity-measure.svg": 39758,
	"./illustrations/category-alcohol.png": 76122,
	"./illustrations/category-baby.png": 74270,
	"./illustrations/category-convenience.png": 13593,
	"./illustrations/category-flowers.png": 78412,
	"./illustrations/category-grocery.png": 66465,
	"./illustrations/category-pharmacy.png": 72749,
	"./illustrations/category-restaurant.png": 93647,
	"./image-square-error.svg": 87904,
	"./image-square-fallback.svg": 47692,
	"./image-square-loading.svg": 32918,
	"./lastmile-profile-icon.png": 55036,
	"./logos/delivereasy-full-stacked-rgb.svg": 72532,
	"./logos/delivereasy-logo-icon.svg": 10537,
	"./logos/delivereasy-logo-orange.svg": 24203,
	"./logos/delivereasy-logo-wide-on-black.svg": 5984,
	"./logos/delivereasy-logo-wide-on-colour.svg": 81363,
	"./logos/delivereasy-logo-wide-on-white.png": 39849,
	"./logos/delivereasy-logo-wide-on-white.svg": 35230,
	"./map/customer-marker-icon.svg": 13998,
	"./map/delivery-address-marker-icon.svg": 74289,
	"./map/delivery-dropoff-marker-icon.svg": 25631,
	"./map/delivery-photo-marker-icon.svg": 93889,
	"./map/driver-marker-icon.svg": 46988,
	"./map/restaurant-marker-icon.svg": 40119,
	"./payment-marks/afterpay.svg": 42785,
	"./payment-marks/apple-pay.svg": 67627,
	"./payment-marks/google-pay.svg": 19546,
	"./payment-marks/mastercard.svg": 57454,
	"./payment-marks/visa.svg": 93161,
	"./premium-bubble.svg": 39582,
	"./restaurant-card-loading.svg": 74271,
	"./restaurant-card-placeholder.svg": 96592
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86190;